(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class MjmCardCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-mjm-slide]'));

      this.index = Math.max(
        0,
        this.slides.findIndex((slide) =>
          slide.classList.contains('is-active')
        )
      );
    }

    show(nextIndex) {
      this.slides.forEach((slide, index) => {
        const active = index === nextIndex;

        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });

      this.index = nextIndex;
    }
  }

  if (!customElements.get('mjm-card-carousel')) {
    customElements.define('mjm-card-carousel', MjmCardCarousel);
  }

  class MjmCardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('product-card');
      this.buttons = Array.from(
        this.querySelectorAll('[data-mjm-swatch]')
      );

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.select(button);
        });
      });
    }

    select(button) {
      if (!this.card) return;

      this.buttons.forEach((item) => {
        const selected = item === button;

        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      const carousel = this.card.querySelector('mjm-card-carousel');
      carousel?.show(0);

      const firstImage =
        this.card.querySelector(
          '.mjm-card__slide.is-active .mjm-card__image'
        ) ||
        this.card.querySelector(
          '[data-mjm-slide] .mjm-card__image'
        );

      const imageUrl = button.dataset.variantImage;

      if (firstImage instanceof HTMLImageElement && imageUrl) {
        firstImage.removeAttribute('srcset');
        firstImage.removeAttribute('sizes');
        firstImage.src = imageUrl;
        firstImage.alt =
          button.dataset.variantImageAlt || firstImage.alt;
      }

      const variantUrl = button.dataset.variantUrl;

      const productLink = this.card.querySelector(
        '[ref="productCardLink"]'
      );

      if (
        productLink instanceof HTMLAnchorElement &&
        variantUrl
      ) {
        productLink.href = variantUrl;
      }

      const currentPrice = this.card.querySelector(
        '.mjm-card__price-current'
      );

      if (currentPrice && button.dataset.variantPrice) {
        currentPrice.textContent =
          button.dataset.variantPrice;
      }

      const priceWrap = this.card.querySelector(
        '.mjm-card__price'
      );

      let comparePrice = this.card.querySelector(
        '.mjm-card__price-compare'
      );

      const nextComparePrice =
        button.dataset.variantComparePrice;

      if (nextComparePrice) {
        if (!comparePrice && priceWrap) {
          comparePrice = document.createElement('s');
          comparePrice.className =
            'mjm-card__price-compare';
          priceWrap.append(comparePrice);
        }

        if (comparePrice) {
          comparePrice.textContent = nextComparePrice;
          comparePrice.hidden = false;
        }

      } else if (comparePrice) {
        comparePrice.hidden = true;
      }

      const mediaLink = this.card.querySelector(
        '.mjm-card__slide.is-active'
      );

      if (
        mediaLink instanceof HTMLAnchorElement &&
        variantUrl
      ) {
        mediaLink.href = variantUrl;
      }
    }
  }

  if (!customElements.get('mjm-card-swatches')) {
    customElements.define(
      'mjm-card-swatches',
      MjmCardSwatches
    );
  }
  } catch(e) { console.error(e); }
})();

})();
